import { render, staticRenderFns } from "./DiscountsGrid.vue?vue&type=template&id=e9b42412"
import script from "./DiscountsGrid.vue?vue&type=script&lang=js"
export * from "./DiscountsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports